import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=c59fc6fa&scoped=true"
import script from "./MessageModal.vue?vue&type=script&lang=js"
export * from "./MessageModal.vue?vue&type=script&lang=js"
import style0 from "./MessageModal.vue?vue&type=style&index=0&id=c59fc6fa&prod&lang=scss&scoped=true"
import style1 from "./MessageModal.vue?vue&type=style&index=1&id=c59fc6fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59fc6fa",
  null
  
)

export default component.exports